import { access2off, access3off, access4off, access2on, access3on, access4on, accessBanner, IconAlarm } from '@assets/images/main/index';

import { BlueIconPhone, BlueIconRFID, BlueIconRemote, BlueIconWatch, BlueIconWidget } from '@assets/images/icon/blue';
import {
  AdvantageImgD,
  AdvantageImgM,
  AdvantageImgT,
  Falldown1D,
  Falldown1M,
  Falldown1T,
  Falldown2D,
  Falldown2M,
  Falldown2T,
  Falldown3D,
  Falldown3M,
  Falldown3T,
  installationImg1D,
  installationImg1M,
  installationImg1T,
  installationImg2D,
  installationImg2M,
  installationImg2T,
  installationImg3D,
  installationImg3M,
  installationImg3T,
  installationImg4D,
  installationImg4M,
  installationImg4T,
  installationImg5D,
  installationImg5M,
  installationImg5T,
  hardwareImg1D,
  hardwareImg1M,
  hardwareImg1T,
  hardwareImg2D,
  hardwareImg2M,
  hardwareImg2T,
  hardwareImg3D,
  hardwareImg3M,
  hardwareImg3T,
  hardwareImg4D,
  hardwareImg4M,
  hardwareImg4T,
  hardwareImg5D,
  hardwareImg5M,
  hardwareImg5T,
  accessBannerProduct,
  accessBannerBg,
} from '@assets/images/main/access/components/index';
import { IconAccessLiteOff, IconAccessLiteOn, IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import { Icon3d3d, Icon3dAlert, Icon3dCycle, Icon3dDetect, Icon3dMap2, Icon3dMeter } from '@assets/images/icon';

export default {
  banner: {
    title: '出入轻松自然，<br/>记录自动完成。',
    desc: '当携带标签或手机的人员接近时，门会自动打开，<br/>出入记录会实时保存至 ORBRO OS。',
    productImg: accessBannerProduct,
    bgImg: accessBannerBg,
    schemeTitle: '请选择适合您的出入系统。',
    schemeDesc: '需要帮助做出决定吗？',
    schemeDesc2: '请联系我们，<br/>出入专家将为您提供协助。',
    phone: '1522-9928',
  },

  func: {
    title: '查看更多功能',

    data: [
      {
        img: IconBlueShield,
        title: '出入认证方式',
        desc: '我们提供多种认证方式，如 BLE（蓝牙）、NFC、AI 人脸识别。不同产品的功能可能有所不同，可根据实际环境进行选择。',
      },
      {
        img: IconAlarm,
        title: '基于手机的自动出入',
        desc: '安装了专用 App 的用户在携带手机靠近门口时，<br/>无需额外操作即可自动认证并打开门。',
      },
      {
        img: Icon3dMeter,
        title: '基于标签的非接触式出入',
        desc: '使用 Access Key 标签时，即使没有手机也可以完成认证。<br/>只需携带标签即可自动控制门禁。',
      },
      {
        img: Icon3dCycle,
        title: '出入权限管理',
        desc: '可按用户或区域设置出入权限，根据安全等级进行访问限制。',
      },
      {
        img: Icon3dMap2,
        title: '自动保存出入记录',
        desc: '出入时间、停留时间、认证方式等信息将实时保存至 ORBRO OS。<br/>管理员可通过后台按日期或用户进行查询。',
      },
      {
        img: Icon3dAlert,
        title: '支持无网络环境',
        desc: '可使用离线模式在没有网络的环境中独立完成出入认证，适用于网络基础设施不足的场所。',
      },
      {
        img: Icon3dDetect,
        title: '支持自动门或独立出入',
        desc: '即使没有自动门，也可通过与 EM 锁、插销等锁具联动，在认证后自动解锁实现出入控制。',
      },
      {
        img: Icon3d3d,
        title: '基于 API 的外部集成',
        desc: 'Access Lite 和 Access Pro 模型支持 API 集成，可与其他安全系统、考勤系统、预约系统等进行整合。',
      },
    ],
  },

  mainPage: {
    product: {
      title: '了解产品组成',
      desc: '了解创新出入系统的产品组成。',
      mobile: {
        title: '移动出入',
        desc: '移动出入系统的起点',
      },
      auto: {
        title: '自动门出入',
        desc: '专为自动门定制的出入系统<br/>适用于所有出入口',
      },
      face: {
        title: '人脸识别出入',
        desc: '人脸识别、移动出入、NFC卡等<br/>多种出入方式',
      },
      accessory: {
        title: '出入配件',
        desc: '了解与出入系统相关的<br/>所有产品',
      },
    },
  },

  FAQ: [
    {
      title: 'Orbro Access 是如何进行出入认证的？',
      description: '根据不同产品，支持 BLE（蓝牙）、NFC、AI 人脸识别等多种认证方式，最基本的是通过手机 App 的位置认证。',
    },
    {
      title: '没有智能手机也能出入吗？',
      description: '可以。使用专用标签 Orbro Access Key 即可无需手机进行认证。',
    },
    {
      title: '没有自动门的地方也能使用吗？',
      description: '可以使用。即使没有自动门，也可通过与 EM 锁或插销联动，使用 Orbro Access 终端控制出入。',
    },
    {
      title: '出入记录是如何保存的？',
      description: '出入时间、停留时间、认证方式等所有记录会自动保存至 ORBRO OS，并可通过后台管理页面查看。',
    },
    {
      title: '在没有网络连接的环境下也能使用吗？',
      description: '可以。在无服务器的环境下也能通过离线模式运行，但该模式下不会保存出入记录。',
    },
    {
      title: '是否支持与外部系统集成？',
      description: 'Access Lite 与 Access Pro 产品支持 API 集成，可轻松对接内部安全系统或出入日志管理系统。',
    },
    {
      title: '支持人脸识别出入吗？',
      description: '支持。Access Pro 模型具备 AI 人脸识别功能，可实现非接触、快速认证，安全性与效率兼具。',
    },
  ],

  bannerData: [
    {
      icon: access2on,
      iconInv: access2off,
      image: '',
      iconText: 'Access Auto',
      titleKey: '专为自动门设计的出入系统<br/>适用于所有类型的门',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/cn/access/auto',
    },
    {
      icon: IconAccessLiteOn,
      iconInv: IconAccessLiteOff,
      image: '',
      iconText: 'Access Lite',
      titleKey: '人脸识别、手机门禁、NFC卡等<br/>支持所有出入方式',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/cn/access/lite',
    },
    {
      icon: access3on,
      iconInv: access3off,
      image: '',
      iconText: 'Access Pro',
      titleKey: '人脸识别、手机门禁、NFC卡等<br/>支持所有出入方式',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/cn/access/pro',
    },
    {
      icon: access4on,
      iconInv: access4off,
      image: '',
      iconText: 'Accessories',
      titleKey: '了解所有<br/>出入系统相关产品',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/cn/access/accessory',
    },
    // 如有更多分类请继续添加
  ],

  falldown: {
    left: {
      title: '在智能手机上集成入口方式，<br/>最现代的访问系统',
      desc: '从普通门到自动门和速通门，您可以轻松使用智能手机访问现代社会的各种入口点。通过使用最接近我们日常生活的系统，体验最有效的数字转型。',

      fall: [
        {
          title: '智能手机入口',
          desc: '可以通过所有iOS/Android智能手机访问。',
          img: {
            desktop: Falldown1D,
            tablet: Falldown1T,
            mobile: Falldown1M,
          },
        },
        {
          title: '智能手表入口',
          desc: '通过智能手表享受更便捷的访问体验。',
          img: {
            desktop: Falldown2D,
            tablet: Falldown2T,
            mobile: Falldown2M,
          },
        },
        {
          title: 'RFID卡入口',
          desc: '可以使用现有的员工工作证访问。',
          img: {
            desktop: Falldown3D,
            tablet: Falldown3T,
            mobile: Falldown3M,
          },
        },
      ],
    },

    rightImg: '',
  },

  functions: {
    title: '核心是硬件，<br/>一切都在平稳创新。',
    desc: '',
    line: 2,
    card: [
      {
        img: {
          desktop: hardwareImg1D,
          tablet: hardwareImg1T,
          mobile: hardwareImg1M,
        },
        tag: '状态LED',
        title: '双通道NFC/蓝牙<br/>访问',
        desc: '通过NFC卡等访问，从移动到智能手表入口都可以。',
        size: '3',
      },
      {
        img: {
          desktop: hardwareImg2D,
          tablet: hardwareImg2T,
          mobile: hardwareImg2M,
        },
        tag: '电源供应',
        title: '通过PoE使用<br/>集成通信和电力',
        size: '1',
      },
      {
        img: {
          desktop: hardwareImg3D,
          tablet: hardwareImg3T,
          mobile: hardwareImg3M,
        },
        tag: '简便安装',
        title: '使用专用支架<br/>方便安装',
        size: '2',
      },
      {
        img: {
          desktop: hardwareImg4D,
          tablet: hardwareImg4T,
          mobile: hardwareImg4M,
        },
        tag: '扬声器',
        title: '通过扬声器<br/>进行访问通知',
        size: '2',
      },
      {
        color: '#000',
        img: {
          desktop: hardwareImg5D,
          tablet: hardwareImg5T,
          mobile: hardwareImg5M,
        },
        tag: '状态LED',
        darkTitle: '即使在黑夜中<br/>',
        lightTitle: '状态检查 ',
        darkTitle2: '也可以',
        desc: '通过RGB LED，您可以检查设备状态、入口确认等。',
        size: '2',
      },
    ],
  },

  installation: {
    title: '不用担心产品安装。<br/>我们为您搞定。',
    card: [
      {
        img: {
          desktop: installationImg1D,
          tablet: installationImg1T,
          mobile: installationImg1M,
        },
        tag: '提供本地服务器',
        title: '企业级<br/>服务器提供',
      },
      {
        img: {
          desktop: installationImg2D,
          tablet: installationImg2T,
          mobile: installationImg2M,
        },
        tag: '专业现场安装支持',
        title: '请拨打1522-9928<br/>了解最早的安装日期',
        desc: '工作日上午9点至下午6点',
      },
      {
        img: {
          desktop: installationImg3D,
          tablet: installationImg3T,
          mobile: installationImg3M,
        },
        tag: '入口配件',
        title: '可以安装死锁',
      },
      {
        img: {
          desktop: installationImg4D,
          tablet: installationImg4T,
          mobile: installationImg4M,
        },
        tag: '入口配件',
        title: '可以安装EM锁',
      },
      {
        theme: 'black',
        img: {
          desktop: installationImg5D,
          tablet: installationImg5T,
          mobile: installationImg5M,
        },
        tag: '入口配件',
        title: '可以安装电动锁',
      },
    ],
  },

  advantage: {
    img: {
      desktop: AdvantageImgD,
      tablet: AdvantageImgT,
      mobile: AdvantageImgM,
    },
    title: 'ORBRO与传统访问系统的不同之处',
    desc: 'ORBRO是提供各种入口方式的最现代访问终端，适应现代社会访问方式的变化，从传统的访问方式到最新的智能技术。它为用户提供了便捷和安全的访问环境。',
    card: [
      {
        icon: BlueIconPhone,
        title: '使用智能手机进行访问',
        desc: '使用iOS / Android应用程序控制入口点。',
      },
      {
        icon: BlueIconWidget,
        title: '提供小部件',
        desc: '小部件是更方便使用移动应用程序的方式。',
      },
      {
        icon: BlueIconWatch,
        title: '使用智能手表进行访问',
        desc: '通过使用智能手表体验便捷的入口方式。',
      },
      {
        icon: BlueIconRemote,
        title: '远程控制',
        desc: '管理员可以远程管理入口点。',
      },
      {
        icon: BlueIconRFID,
        title: 'RFID和NFC卡',
        desc: '通过标记RFID或NFC标签轻松控制入口点。',
      },
    ],
  },
};
